import { Injectable } from '@angular/core';
import { ChatsystemOptionInterface } from '@monsido/core/session/chatsystem-option.interface';

export interface ChatSystemConfig {
    system: string;
    options?: ChatsystemOptionInterface;
    entire_env?: boolean;
    reseller?: number;
}

export interface ChatEnvironment {
    [key: string]: ChatSystemConfig[];
}

export interface ChatSystemsConfig {
    intercom: {
        intercomId: string;
        fallbackMail?: string;
    };
    environments: ChatEnvironment;
}

@Injectable({
    providedIn: 'root',
})
export class ChatConfigService {
    private config: ChatSystemsConfig;

    constructor () {
    // Initialize with default empty config
        this.config = {
            intercom: {
                intercomId: '',
                fallbackMail: '',
            },
            environments: {},
        };
    }

    setConfig (config: ChatSystemsConfig): void {
        this.config = config;
    }

    getConfig (): ChatSystemsConfig {
        return this.config;
    }

    getFallbackMail (): string {
        return this.config.intercom.fallbackMail || '';
    }

    getIntercomId (): string {
        return this.config.intercom.intercomId;
    }

    getEnvironmentConfig (environment: string): ChatSystemConfig[] {
        return this.config.environments[environment] || [];
    }
}
